import React from "react";
import BaseSection from "../components/BaseSection";
import { IoMdOptions } from "react-icons/io";
import { Grid, Button } from "@material-ui/core";
import CheckCircleOutlinedIcon from '@material-ui/icons/CheckCircleOutlined';
import BlockOutlinedIcon from '@material-ui/icons/BlockOutlined';
import SwitchInput from "../components/Input/SwitchInput";
import { SectionHeader, FeaturesContainer, ActionsContainer, TextButton } from "./styles";

export const FEATURES_SECTION_INPUTS = {
  BLOCKED_FEATURES: "blocked_features",
};

const MENU_FEATURES = [
  { label: "Acessos", slug: "acessos" },
  { label: "Times", slug: "times" },
  { label: "Trilhas", slug: "trilhas" },
  { label: "Cursos", slug: "cursos" },
  { label: "Aulas ao vivo", slug: "aulas_ao_vivo" },
  { label: "Dúvidas", slug: "duvidas" },
  { label: "Mapeamento de Compet.", slug: "mapeamento_competencias" },
  { label: "Logs do Sistema", slug: "logs_sistema" },
  { label: "Relatórios", slug: "relatorios" },
  { label: "Comunicados", slug: "comunicados" },
  { label: "Chave de Acesso", slug: "chave_acesso" },
  { label: "Ranking", slug: "ranking" },
];

const ACTION_FEATURES = [
  { label: "Criar curso", slug: "criar_curso" },
  { label: "Criar aula ao vivo", slug: "criar_aula_ao_vivo" },
  { label: "Criar time", slug: "criar_time" },
  { label: "Criar trilha", slug: "criar_trilha" },
  { label: "Cadastrar aluno", slug: "cadastrar_aluno" },
  { label: "Atribuir curso", slug: "atribuir_curso" },
  { label: "Indicar livro", slug: "indicar_livro" },
];

const PLAYER_FEATURES = [
  { label: "Ocultar Controles do YouTube", slug: "ocultar_controles_youtube" },
];

const ALL_SLUGS = [...MENU_FEATURES, ...ACTION_FEATURES, ...PLAYER_FEATURES].map(f => f.slug);

export default function FeaturesSection({
  inputs = {},
  onChangeInput = () => null,
}) {
  const blockedFeatures = inputs[FEATURES_SECTION_INPUTS.BLOCKED_FEATURES] || [];

  const handleToggle = (slug, isChecked) => {
    let currentBlocked = [...blockedFeatures];
    if (isChecked) {
      currentBlocked = currentBlocked.filter((item) => item !== slug);
    } else {
      if (!currentBlocked.includes(slug)) currentBlocked.push(slug);
    }
    onChangeInput(FEATURES_SECTION_INPUTS.BLOCKED_FEATURES, currentBlocked);
  };

  const handleEnableAll = () => onChangeInput(FEATURES_SECTION_INPUTS.BLOCKED_FEATURES, []);
  const handleDisableAll = () => onChangeInput(FEATURES_SECTION_INPUTS.BLOCKED_FEATURES, ALL_SLUGS);

  return (
    <BaseSection title="Controle de Funcionalidades" Icon={<IoMdOptions />}>
      <FeaturesContainer>
        
        <ActionsContainer>
          <TextButton 
            onClick={handleEnableAll}
            startIcon={<CheckCircleOutlinedIcon />}
          >
            Ativar Todas as Funcionalidades
          </TextButton>
          <TextButton 
            onClick={handleDisableAll}
            startIcon={<BlockOutlinedIcon />}
          >
            Desativar Todas as Funcionalidades
          </TextButton>
        </ActionsContainer>

        <SectionHeader>Itens do Menu Principal</SectionHeader>
        <Grid container spacing={3}>
          {MENU_FEATURES.map((feature) => {
            const isActive = !blockedFeatures.includes(feature.slug);
            return (
              <Grid item xs={3} key={feature.slug}>
                <SwitchInput
                  label={feature.label}
                  name={feature.slug}
                  text={isActive ? "ATIVO" : "INATIVO"}
                  checked={isActive}
                  onChange={(e) => handleToggle(feature.slug, e.target.checked)}
                />
              </Grid>
            );
          })}
        </Grid>

        <SectionHeader style={{ marginTop: "2rem" }}>
          Ações e Permissões Internas
        </SectionHeader>
        <Grid container spacing={3}>
          {ACTION_FEATURES.map((feature) => {
            const isActive = !blockedFeatures.includes(feature.slug);
            return (
              <Grid item xs={3} key={feature.slug}>
                <SwitchInput
                  label={feature.label}
                  name={feature.slug}
                  text={isActive ? "ATIVO" : "INATIVO"}
                  checked={isActive}
                  onChange={(e) => handleToggle(feature.slug, e.target.checked)}
                />
              </Grid>
            );
          })}
        </Grid>
        <SectionHeader style={{ marginTop: "2rem" }}>
          Configurações de Player / Vídeo
        </SectionHeader>
        <Grid container spacing={3}>
          {PLAYER_FEATURES.map((feature) => {
            const isActive = !blockedFeatures.includes(feature.slug);
            return (
              <Grid item xs={3} key={feature.slug}>
                <SwitchInput
                  label={feature.label}
                  name={feature.slug}
                  text={isActive ? "ATIVO" : "INATIVO"}
                  checked={isActive}
                  onChange={(e) => handleToggle(feature.slug, e.target.checked)}
                />
              </Grid>
            );
          })}
        </Grid>

      </FeaturesContainer>
    </BaseSection>
  );
}